import { render, staticRenderFns } from "./LightingTab.vue?vue&type=template&id=5aa05804"
import script from "./LightingTab.vue?vue&type=script&lang=js"
export * from "./LightingTab.vue?vue&type=script&lang=js"
import style0 from "./LightingTab.vue?vue&type=style&index=0&id=5aa05804&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports